import Vue from 'vue'

import currencyUtils from 'src/utils/currentUtils'

Vue.filter('venueCurrency', (value, currencyCode = 'USD', languageCode = 'en') => {
  return currencyUtils.venueCurrency(value, currencyCode, languageCode)
})



// WEBPACK FOOTER //
// ./src/filters/venueCurrency.js